import { render, staticRenderFns } from "./IconModal.vue?vue&type=template&id=3aa61049&scoped=true&"
import script from "./IconModal.vue?vue&type=script&lang=ts&"
export * from "./IconModal.vue?vue&type=script&lang=ts&"
import style0 from "./IconModal.vue?vue&type=style&index=0&id=3aa61049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa61049",
  null
  
)

export default component.exports